module.exports = __webpack_public_path__ + "static/media/digital-marketing.5f290e6b.svg";